import { APP_CONFIG } from '@/lib/app/config';
import { Platform } from 'react-native';

function getAPIOrigin() {
  try {
    return new URL(APP_CONFIG.apiBaseURL).origin;
  } catch {
    return null;
  }
}

export function resolveAPIAssetURL(publicURL: string, pathPrefix: string) {
  const trimmed = publicURL.trim();
  if (!trimmed || Platform.OS === 'web') {
    return trimmed;
  }

  const apiOrigin = getAPIOrigin();
  if (!apiOrigin) {
    return trimmed;
  }

  if (trimmed.startsWith(pathPrefix)) {
    return `${apiOrigin}${trimmed}`;
  }

  try {
    const parsed = new URL(trimmed);
    const isLocalhost = parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1';
    if (isLocalhost && parsed.pathname.startsWith(pathPrefix)) {
      return `${apiOrigin}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return trimmed;
  }

  return trimmed;
}
